import { all, delay, race, select, take, takeEvery, takeLatest } from '@redux-saga/core/effects';
import { ChatViewMode } from 'enums/ChatViewMode';
import { OverlayType } from 'enums/OverlayType';
import { DefaultRootState } from 'react-redux';
import { put } from 'redux-saga/effects';

import { ChatActionType } from '../chat/chat.actions';
import { FileActionType } from '../files/files.actions';
import { GameActionType, setShowGameStarter } from '../game/game.actions';
import { HistoryActionType } from '../history/history.actions';
import { fallAsleep, SlumberActionType, wakeUp } from './slumber.actions';

// A list of actions that will "wake up" the chat
export const wakeActions = [
    HistoryActionType.ReceiveHistory,
    HistoryActionType.SendMessage,
    HistoryActionType.ReceiveMessage,
    FileActionType.UploadFile,
    FileActionType.ClearFile,
    ChatActionType.SetOpen,
    ChatActionType.SetViewMode,
    ChatActionType.SendTyping,
    ChatActionType.ReceiveAgentTyping,
];

const fallAsleepTimeout = 10; // Seconds

function* wakeOnActionsSaga() {
    yield takeEvery(wakeActions, function* () {
        const asleep = yield select((state: DefaultRootState) => state.asleep);

        if (asleep) {
            yield put(wakeUp());
        }
    });
}

function* wakeUpSaga() {
    yield takeLatest(SlumberActionType.WakeUp, function* () {
        const showStarter = yield select((state: DefaultRootState) => state.game.showStarter);

        if (showStarter) {
            yield put(setShowGameStarter(false));
        }

        yield delay(fallAsleepTimeout * 1000);

        const asleep = yield select((state: DefaultRootState) => state.asleep);

        if (!asleep) {
            yield put(fallAsleep());
        }
    });
}

const hideGameStarterTimeout = 30; // Seconds

function* fallAsleepSaga() {
    yield takeLatest(SlumberActionType.FallAsleep, function* () {
        const chatViewMode = yield select((state: DefaultRootState) => state.chat.viewMode);

        const gameWidgetOpen = yield select(
            (state: DefaultRootState) => state.chat.overlay?.type === OverlayType.CoinGame,
        );

        const starterWasShown = yield select(
            (state: DefaultRootState) => state.game.starterWasShown,
        );

        if (chatViewMode === ChatViewMode.Normal && !gameWidgetOpen && !starterWasShown) {
            yield put(setShowGameStarter(true));

            const { play } = yield race({
                play: take(GameActionType.OpenWidget),
                cancel: delay(hideGameStarterTimeout * 1000),
            });

            if (!play) {
                const showStarter = yield select(
                    (state: DefaultRootState) => state.game.showStarter,
                );

                if (showStarter) {
                    yield put(setShowGameStarter(false));
                }
            }
        }
    });
}

export function* slumberSaga() {
    yield all([wakeOnActionsSaga(), wakeUpSaga(), fallAsleepSaga()]);
}
